module.exports={author:"Joshua Nguyen",date:"09/27/2021",publishDate:"09/27/2021",highlighted:!1,tags:"",title:"Save Me, Marie Kondo",badge:""};